export default {
  eventId: {
    'ui:widget': 'EditorEventIdWidget',
  },
}
